import {IQuestion} from '@services/live-event/live-event.model';
import {ILiveEvent} from '@services/live-events/live-events.model';

export const MutationKey = {
    LOGIN: 'login',
    REGISTER: 'register',
    UPDATE_PAYMENT_METHOD: 'payment',
    PAYMENT_PP: 'paymentPP',
    PAYMENT_CC: 'paymentCC',
    PAYMENT_DD: 'paymentDD',
    CHECKOUT: 'checkout',
    ONBOARDING_SUBMIT_SURVEY: 'onboardingSubmitSurvey',
    ONBOARDING_USER_TYPE: 'onboardingUserType',
    COUPON_VALIDATION: 'couponValidation',
    PASSWORD_RESET: 'passwordReset',
    NEW_PASSWORD: 'newPassword',
    UPDATE_PASSWORD: 'updatePassword',
    UPDATE_USER: 'updateUser',
    UPDATE_PROFILE_AVATAR: 'updateProfileAvatar',
    UPDATE_USERNAME: 'updateUsername',
    DOWNLOAD_INVOICE: 'downloadInvoice',
    SUBSCRIPTION_CANCEL: 'subscriptionCancel',
    SUBSCRIPTION_RESUME: 'subscriptionResume',
    FAVORITE_TOGGLE: (courseId: number) => ['favoriteToggle', courseId],
    LIVE_EVENTS: 'liveEvents',
    LIVE_EVENT_SIGNUP_TOGGLE: (liveEventId: ILiveEvent['id']) => [
        'liveEventSignupToggle',
        liveEventId,
    ],
    LIVE_EVENT_QUESTION_CREATE: (liveEventId: ILiveEvent['id']) => [
        'liveEventQuestion',
        liveEventId,
    ],
    LIVE_EVENT_QUESTION_UPVOTE_TOGGLE: (questionId: IQuestion['id']) => [
        'upvoteQuestionToggle',
        questionId,
    ],
    LIVE_EVENT_RECORDING_WATCHTIME: (
        webinarId: number,
        recordingId: number,
    ) => ['updateLiveEventRecordingWatchtime', webinarId, recordingId],
    COURSE_PROGRESS: (courseId: number, videoId: number) => [
        'courseProgress',
        courseId.toString(),
        videoId.toString(),
    ],
    SUPER_COURSE_RESET_PROGRESS: (courseId: number) => [
        'superCourseResetProgress',
        courseId,
    ],
    DISCUSSION_SPACE_CONTRIBUTION: (slug: string) => ['discussionSpace', slug],
    SUPER_COURSE_PROGRESS_DONE: 'superCourseProgressDone',
    INVALIDATE_TAG: 'INVALIDATE_TAG',
    PURGE_GATEWAY_CACHE: 'PURGE_GATEWAY_CACHE',
    UPGRADE_SUBSCRIPTION: 'UPGRADE_SUBSCRIPTION',
    RECOMMENDATION_PREFERENCE: 'RECOMMENDATION_PREFERENCE',
    NOTIFICATION_MARK_AS_READ: 'NOTIFICATION_MARK_AS_READ',
};
